import { TriangleAlert } from 'lucide-react'
import { use } from 'react'
import { CompanySuspensionContext } from '@/components/company-suspension/context'
import { Button } from '@/components/ui/button'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import { Separator } from '@/components/ui/separator'
import { useIdCompany } from '@/lib/hooks'

export const OtherSuspensionNotice = () => {
  const { isSuspended, suspensionReason } = use(CompanySuspensionContext)
  const { idCompany } = useIdCompany()

  const hasSpecificNotice =
    suspensionReason === 'payment' || suspensionReason === 'fraud'

  if (!isSuspended || hasSpecificNotice || !idCompany) {
    return null
  }

  return (
    <>
      <Popover>
        <PopoverTrigger asChild>
          <Button variant="destructive" size="sm">
            <TriangleAlert className="size-4" />
            <span>Account is suspended</span>
          </Button>
        </PopoverTrigger>
        <PopoverContent align="end" className="flex w-80 flex-col gap-1">
          <span className="text-sm font-medium">Your account is suspended</span>
          <p className="text-sm text-muted-foreground">
            Your account has been suspended. If you believe this is a mistake,
            please contact support.
          </p>
        </PopoverContent>
      </Popover>
      <Separator orientation="vertical" className="h-4!" />
    </>
  )
}
